import { Button, Card, CardBody, Col, Form, Input } from "reactstrap";
import { Bio, BioText, MyProfiles, Save } from "../../../../../constants";
import CommonUserFormGroup from "../common/CommonUserFormGroup";
import { UserFormHead } from "./UserFormHead";
import CommonCardHeader from "../../../../../coreComponents/CommonCardHeader";

const MyProfile = () => {

  return (
    <Col xl="4">
      <Card>
        <CommonCardHeader title={MyProfiles} headClass="pb-0" />
        <CardBody>
          <Form onSubmit={(event) => event.preventDefault()}>
            <UserFormHead />
            <div className="mb-3">
              <h6 className="form-label">{Bio}</h6>
              <Input type="textarea" rows={4} defaultValue={BioText} />
            </div>
            <CommonUserFormGroup type="email" title="Email-Address" placeholder="your-email@domain.com" />
            <CommonUserFormGroup type="password" title="Password" defaultValue="Password" />
            <CommonUserFormGroup type="email" title="Website" placeholder="http://Uplor.com" />
            <div>
              <Button color="primary" className="d-block">
                {Save}
              </Button>
            </div>
          </Form>
        </CardBody>
      </Card>
    </Col>
  );
};

export default MyProfile;
